import { takeUntil } from 'rxjs/operators';
import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TableColumnsConfigKey } from '@app/core/models/configuration/table-columns-config-key.model';
import { InvoiceModel } from '@app/core/models/invoices/invoice.model';
import { FileDownloadService } from '@app/core/services/filedownload.service';
import { HttpCancelService } from '@app/core/services/http-cancel.service';
import { InvoiceService } from '@app/core/services/invoice.service';
import { ProgressComponent } from '@app/shared/components/progress/progress.component';
import { ModalHelper } from '@app/shared/models/modal-helper.model';
import {
  TableActionIcon,
  TableIndication,
  TableMassAction,
  TableRowAction,
} from '@app/shared/models/table-action-type.model';
import { BehaviorSubject, Subject } from 'rxjs';
import * as _ from 'lodash';
import { InvoiceViewType } from '@app/core/models/invoices/invoice-view-type.model';
import { WorkflowStageValidationModel } from '@app/core/models/workflows/workflow-stage-validation.model';
import { WorkflowStageValidationComponent } from '@app/features/workflow-stage-validation/workflow-stage-validation.component';
import { ModalComponent } from '@app/shared/components/modal/modal.component';
import * as moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import { ReferentialItem } from '@app/core/models/shared/referential-item.model';
import { InvoiceFilterService } from '../invoice-filter-service';
import { AssetService } from '@app/core/services/asset.service';
import { RecipientEntitiesService } from '@app/core/services/recipient-entities.service';
import { SessionStorageService } from '@app/core/services/session-storage.service';
import { InvoiceFilters } from '@app/core/models/invoices/invoice-filters.model';
import { DropdownHelper } from '@app/shared/models/dropdown-helper.model';
import { InvoiceFilterConfig } from '@app/core/models/invoices/invoice-filter-config.model';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { MultiSelectModel } from '@app/shared/models/multi-select.model';
import { InvoiceListPPRErrorsComponent } from '../../actions/listPPRErrors/invoice-list-pprerrors/invoice-list-pprerrors.component';
import { InvoicePPRLogModel } from '@app/core/models/invoices/invoice-pprlog.model';

@Component({
  selector: 'app-invoice-list-promotion-workflow',
  templateUrl: './invoice-list-promotion-workflow.component.html',
  styleUrls: ['./invoice-list-promotion-workflow.component.scss'],
})
export class InvoiceListPromotionWorkflowComponent
  extends InvoiceFilterService
  implements OnInit, OnDestroy
{
  invoices: InvoiceModel[];
  data: InvoiceModel[] = [];
  tableActions: TableRowAction[] = [];
  tableMassActions: TableMassAction[] = [];
  tableIndications: TableIndication[] = [];
  unsubscribe$: Subject<boolean> = new Subject<boolean>();
  configKey: string = TableColumnsConfigKey.INVOICEPROMOTIONWORKFLOW;
  exportFileName: string;
  private massDownloadRequestSubject$ = new BehaviorSubject<string>(null);
  public massDownloadRequest$ = this.massDownloadRequestSubject$.asObservable();
  progressDialog: MatDialogRef<ProgressComponent>;

  dropdownSettings: IDropdownSettings = {};

  panelOpenState: boolean = true;
  dropdownListComplaint: ReferentialItem[] = [];
  selectedItemsComplaint: ReferentialItem[] = [];

  title: string;

  public onFiltersCleared: EventEmitter<void> = new EventEmitter<void>();
  public onExportExcelCaller: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private invoiceService: InvoiceService,
    private fileDownloadService: FileDownloadService,
    private router: Router,
    private httpCancelService: HttpCancelService,
    private dropdownHelper: DropdownHelper,
    private multiSelectModel: MultiSelectModel,
    public route: ActivatedRoute,
    public dialog: MatDialog,
    public assetService: AssetService,
    public recipientEntitiesServie: RecipientEntitiesService,
    protected sessionStorageService: SessionStorageService
  ) {
    super(route, sessionStorageService, assetService, recipientEntitiesServie);
    this.invoiceFiltersConfig = new InvoiceFilterConfig(
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true
    );
    this.title = 'FACTURES A VALIDER PROMOTION';
    this.exportFileName = 'Factures_A_Valider_Promotion';
  }

  ngOnInit(): void {
    this.route.data.subscribe((data) => (this.invoices = data.invoices));
    this.data = this.invoices;
    this.tableActions.push(
      new TableRowAction(
        TableActionIcon.ZOOM,
        'Voir le détail de la facture',
        this.onZoom
      )
    );
    this.tableActions.push(
      new TableRowAction(
        TableActionIcon.PDF,
        'Ouvrir la facture',
        this.onOpenPdf
      )
    );
    this.tableActions.push(
      new TableRowAction(
        TableActionIcon.PROCESS,
        'Valider la facture',
        this.onWorkflowStageValidation,
        this.ensureInvoiceIsNotComplaint
      )
    );
    this.tableActions.push(
      new TableRowAction(
        TableActionIcon.VOUCHER,
        'Télécharger le bon à payer',
        this.onPromotionDownload
      )
    );
    this.tableMassActions.push(
      new TableMassAction(
        TableActionIcon.PROCESS,
        'Valider les factures',
        this.onWorkflowStagesValidation,
        this.ensureSelectedItemsIsNotComplaint
      )
    );
    this.tableMassActions.push(
      new TableMassAction(
        TableActionIcon.VOUCHER,
        'Télécharger les bons à payer',
        this.onMassPromotionsDownload
      )
    );
    this.tableIndications.push(
      new TableIndication(
        TableActionIcon.ERROR,
        "L'association Référence 1 et société n'est pas conforme",
        (invoice: InvoiceModel) => invoice.SupplierHasWarning
      )
    );
    this.tableActions.push(
      new TableRowAction(
        TableActionIcon.PPR_ERROR,
        'Historique des retours PPR',
        this.onListPPRErrors,
        (invoice: InvoiceModel) => invoice.InvoicePPRLogsErrorCount > 0
      )
    );

    this.dropdownSettings = this.multiSelectModel.getSingleSelection(false);

    this.restoreFilters((data) => {
      this.selectedItemsComplaint = data?.Complaint ?? [
        { Id: 0, Label: 'Non' },
      ];
      this.filterData(true);
    });

    this.dropdownListComplaint = this.dropdownHelper.getYesOrNoDropdownList();

    this.massDownloadRequest$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((requestId: string) => {
        if (_.isNil(requestId)) {
          if (!_.isNil(this.progressDialog)) {
            this.progressDialog.close(false);
          }
          return;
        }

        const progressModal = new ModalHelper().getProgressConfig(requestId);
        this.progressDialog = this.dialog.open(
          ProgressComponent,
          progressModal
        );

        this.progressDialog
          .afterClosed()
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe((isSuccess: boolean) => {
            this.massDownloadRequestSubject$.next(null);
            this.progressDialog = null;
            if (!isSuccess) {
              this.httpCancelService.cancelPendingRequests();
            }
          });
      });
  }

  onListPPRErrors = (data: InvoiceModel) => {
    this.invoiceService
      .getErrorsPPRById(data.Id)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((invoicePPRLogs: InvoicePPRLogModel[]) => {
        data.InvoicePPRLogs = invoicePPRLogs;

        const modalConfig = new ModalHelper().getInvoicePPRLogsConfig(data);
        const dialog = this.dialog.open(
          InvoiceListPPRErrorsComponent,
          modalConfig
        );

        return dialog
          .afterClosed()
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe();
      });
  };

  onZoom = (data: InvoiceModel) => {
    this.router.navigate([
      'invoices',
      InvoiceViewType.PROMOTIONWORKFLOW,
      'detail',
      data.Id,
    ]);
  };

  onOpenPdf = (data: InvoiceModel) => {
    window.open(
      `invoices/${InvoiceViewType.PROMOTIONWORKFLOW}/detail-pdf/${data.Id}`,
      '_blank'
    );
  };

  onPromotionDownload = (invoice: InvoiceModel) => {
    this.invoiceService
      .getAttachmentPromotion(invoice.Id)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (blobData: Blob) => {
          let date = moment(invoice.IssuedAt).format('YYYYMMDo');
          this.fileDownloadService.downloadBlob(
            blobData,
            `${invoice.SupplierCompanyName}_${invoice.Number}_${date}.pdf`,
            'application/pdf'
          );
        },
        (_) => {
          const modalErreurConfig = new ModalHelper().getAlertConfig(
            `Une erreur est survenue lors du téléchargement.`
          );
          this.dialog.open(ModalComponent, modalErreurConfig);
        }
      );
  };

  onWorkflowStageValidation = (data: InvoiceModel) => {
    const workflowStageValidationConfig =
      new ModalHelper().getWorkflowStageValidationConfig(
        data.Id,
        data.Number,
        'facture',
        null,
        data.WorkflowPromotionCurrentStage.Level,
        true
      );
    workflowStageValidationConfig.data.ApproveWorkflowStage = (
      invoiceId: string,
      validation: WorkflowStageValidationModel
    ) =>
      this.invoiceService.approveCurrentWorkflowStagePromotion(
        invoiceId,
        validation
      );
    const dialog = this.dialog.open(
      WorkflowStageValidationComponent,
      workflowStageValidationConfig
    );

    return dialog
      .afterClosed()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((isSuccess: boolean) => {
        if (isSuccess) {
          this.data = this.data.filter((i) => i.Id != data.Id);
        }
      });
  };

  ensureInvoiceIsNotComplaint = (invoice: InvoiceModel): boolean => {
    return !invoice.IsComplaint;
  };

  ensureSelectedItemsIsNotComplaint = (data: string[]): boolean => {
    const selectedInvoices = this.data.filter((invoice: InvoiceModel) =>
      data.includes(invoice.Id)
    );
    return !selectedInvoices.some(
      (invoice: InvoiceModel) => !this.ensureInvoiceIsNotComplaint(invoice)
    );
  };

  onMassPromotionsDownload = (selectedIds: string[]) => {
    if (selectedIds.length > 0) {
      let massDownloadRequest = uuidv4();
      this.massDownloadRequestSubject$.next(massDownloadRequest);
      this.invoiceService
        .getAttachmentPromotions(selectedIds, massDownloadRequest)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (blobData: Blob) => {
            this.massDownloadRequestSubject$.next(null);
            let localDate = new Date().toLocaleDateString();
            this.fileDownloadService.downloadBlob(
              blobData,
              `${this.configKey}_${localDate}.zip`,
              'application/zip'
            );
          },
          (_) => {
            this.massDownloadRequestSubject$.next(null);
            const modalErreurConfig = new ModalHelper().getAlertConfig(
              `Une erreur est survenue lors du téléchargement.`
            );
            this.dialog.open(ModalComponent, modalErreurConfig);
          }
        );
    }
  };

  onWorkflowStagesValidation = (invoicesId: string[]) => {};

  ngOnDestroy() {
    this.unsubscribe$.next(true);
  }

  onClearFilters = (): void => {
    this.onFiltersCleared.next();
  };

  exportAsExcel(): void {
    this.onExportExcelCaller.next();
  }

  filterData(persist: boolean) {
    this.invoiceSearchCriteriaModel.IsComplaint =
      this.selectedItemsComplaint && this.selectedItemsComplaint.length == 1
        ? this.selectedItemsComplaint[0].Label == 'Oui'
        : '';
    this.data = this.innerFilterInvoices(
      this.invoices,
      this.getFilters(),
      persist
    );
  }

  onSelectAll(items: any, filter: string) {
    switch (filter) {
      case 'IsComplaint':
        this.selectedItemsComplaint = items;
        break;
    }
    this.filterData(true);
  }

  private getFilters(): InvoiceFilters {
    return {
      Complaint: this.selectedItemsComplaint,
    } as InvoiceFilters;
  }

  protected onAssetFetched(assets: ReferentialItem[]) {}

  protected onRecipientEntitiesFetched(recipientEntities: ReferentialItem[]) {}

  onShowFilter(panelvalue: boolean) {
    this.panelOpenState = panelvalue;
  }
}
